import React from 'react';

export const TrianglePointIcon: React.FC = ({width}: any) => (
    <svg
        width={width}
        height={width}
        viewBox={`0 0 20 18`}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path d="M10 0L20 18H0L10 0Z" fill="currentColor" />
    </svg>
);

export default TrianglePointIcon;
